// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"d0eb03cb","845":"563774f7","880":"3fa50878"}[chunkId] + ".chunk.js";
};